import React, { useEffect, useState } from "react";
import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";
import { useLocation } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";

const ServiceHistory = ({ onChange }) => {
  const initialServiceHistory = {
    ServiceDetails: "",
    Amount: "",
    Date: "",
    Type: "",
  };

  const [serviceHistory, setServiceHistory] = useState([initialServiceHistory]);

  const [base_url] = useState(base_url_from_axios_config);

  const location = useLocation();
  useEffect(() => {
    if (location.state?.item) {
      const registrationNumber = location.state?.item.REG_NO;
      fetchServiceHistory(registrationNumber);
    }
  }, [location.state]);

  const fetchServiceHistory = async (regNo) => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    const companyCode = storedUserDataArray[0]?.cmpcode || null;
    try {
      if (!regNo) return;

      const apiURL = `${base_url}/api/CpaysCount/${companyCode}/VEHICLESERVICESINGLE/${regNo}/-`;

      const response = await axios.get(apiURL);

      const data = response?.data || [];

      console.log("VEHICLE SERVICE SINGLE data:", data);

      setServiceHistory(data);
      onChange(data);
    } catch (error) {
      console.error("Error fetching VEHICLE SERVICE SINGLE:", error);
    }
  };

  const handleChange = (index, name, value) => {
    const updated = [...serviceHistory];
    updated[index][name] = value;
    setServiceHistory(updated);
    onChange(updated);
  };

  const onAddRow = () => {
    const updated = [...serviceHistory, initialServiceHistory];
    setServiceHistory(updated);
  };

  const onDeleteRow = (index) => {
    const updated = serviceHistory.filter((_, i) => i !== index);
    setServiceHistory(updated);
    onChange(updated);
  };

  return (
    <div>
      <table className="min-w-full bg-white rounded-sm border border-[gray-300] text-xs">
        <thead>
          <tr className="bg-[#2663EB] text-white text-sm">
            <th className="px-2 py-1 font-semibold">Sl No</th>
            <th className="px-2 py-1 font-semibold">Service Details</th>
            <th className="px-2 py-1 font-semibold">Amount</th>
            <th className="px-2 py-1 font-semibold">Date</th>
            <th className="px-2 py-1 font-semibold">Type</th>
            <th className="px-2 py-1 font-semibold text-center">Actions</th>
          </tr>
        </thead>

        <tbody>
          {serviceHistory.map((row, index) => (
            <tr key={index}>
              <td className="border">
                <div className="flex gap-2 pl-2">{index + 1}</div>
              </td>

              <td className="border">
                <input
                  type="text"
                  value={row.ServiceDetails || row.AffectOTCalc || ""}
                  onChange={(e) =>
                    handleChange(index, "ServiceDetails", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                />
              </td>
              <td className="border">
                <input
                  type="text"
                  value={row.Amount || ""}
                  onChange={(e) =>
                    handleChange(index, "Amount", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                />
              </td>

              <td className="border">
                <input
                  type="date"
                  value={
                    row.Date || dayjs(row.ADate).format("YYYY-MM-DD") || ""
                  }
                  onChange={(e) => handleChange(index, "Date", e.target.value)}
                  className="w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                />
              </td>

              <td className="border">
                <input
                  type="text"
                  value={row.Type || row.SERVICE_TYPE || ""}
                  onChange={(e) => handleChange(index, "Type", e.target.value)}
                  className="w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                />
              </td>

              <td className="border text-center">
                <button
                  type="button"
                  onClick={onAddRow}
                  className="px-3 py-1.5 mr-2 text-xs font-semibold rounded-xl bg-green-600 hover:bg-green-700 text-white"
                >
                  Add Row
                </button>

                {serviceHistory.length > 1 && (
                  <button
                    type="button"
                    onClick={() => onDeleteRow(index)}
                    className="px-3 py-1.5 text-xs font-semibold rounded-xl bg-red-500 hover:bg-red-600 text-white"
                  >
                    Delete
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ServiceHistory;
